export default __webpack_public_path__ + "56be54bb387aebc6b1904e5cefe10486.png";